var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFamiliplusptsIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23934 14C4.91563 14 4.65192 13.7416 4.65192 13.4245V10.5035C4.65192 9.83976 4.10084 9.30136 3.425 9.30136H0.587408C0.263699 9.30136 0 9.04299 0 8.72583V5.27572C0 4.95856 0.263699 4.70019 0.587408 4.70019H3.425C4.10242 4.70019 4.65192 4.16024 4.65192 3.49807V0.575533C4.65192 0.258371 4.91563 0 5.23934 0H8.76066C9.08437 0 9.34807 0.258371 9.34807 0.575533V3.49652C9.34807 4.16024 9.89916 4.69864 10.575 4.69864H13.4126C13.7363 4.69864 14 4.95701 14 5.27417V8.72428C14 9.04144 13.7363 9.29981 13.4126 9.29981H10.575C9.89758 9.29981 9.34807 9.83976 9.34807 10.5019V13.4229C9.34807 13.7401 9.08437 13.9985 8.76066 13.9985H5.23934V14ZM5.77938 4.60117C5.10196 4.60117 4.55245 5.14112 4.55245 5.80329V8.19671C4.55245 8.86043 5.10354 9.39883 5.77938 9.39883H8.2222C8.89962 9.39883 9.44913 8.85888 9.44913 8.19671V5.80329C9.44913 5.13957 8.89804 4.60117 8.2222 4.60117H5.77938Z",
    fill: "#E52326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamiliplusptsIcn);
export default __webpack_public_path__ + "static/media/Familiplus pts Icn.5bff2dcfdb1750ef17957ad5fcb023eb.svg";
export { ForwardRef as ReactComponent };